import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { FaBarsStaggered } from "react-icons/fa6";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showLoginButton, setShowLoginButton] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 500) {
      setShowLoginButton(true);
    } else {
      setShowLoginButton(false);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);


 const handleDrawerToggle = () => {
    setIsOpen(!isOpen);
  };
  const handleNavLinkClick = () => {
    setIsOpen(false); 
  };

  return (
    <div>
      <header>
        <div className="header position-relative">
          <div className="nav-top">
            <div className="container d-flex align-items-center justify-content-between position-lg-relative">
              <div className="logo-wrapper">
                <NavLink className="big-logo" to="/dashboard" onClick={handleDrawerToggle}>
                  <img src="./logo/Poll_Sphere_Logo-04.png" alt="Logo" />
                </NavLink>
              </div>
              <div className="d-flex align-items-center">
                <div className={isOpen ? "nav-menu open" : "nav-menu "}>
                  <ul>
                   <li>
                      <a href="#how-it-works" onClick={handleNavLinkClick}>How It Works</a>
                    </li>
                    <li>
                      <a href="#referral" onClick={handleNavLinkClick}>Referral</a>
                    </li>
                     <li>
                      <a href="#app" onClick={handleNavLinkClick}>App</a>
                    </li>
                   
                    <li>
                      <a href="#faq" onClick={handleNavLinkClick}>FAQ</a>
                    </li>
                  </ul>
                </div>
                <div className="bar me-4" onClick={handleDrawerToggle}>
                  <FaBarsStaggered />
                </div>
                {/* {showLoginButton && (
                  <div className="wrapper d-flex align-items-center justify-content-end">
                    <LoginButton />
                  </div>
                )} */}
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Header;
